import React, {useState, useEffect} from 'react';
import { Button, Modal, Row, Col, ListGroup, Card } from 'react-bootstrap';
import { FaCopy } from "react-icons/fa6";

import * as functionHelper from '../common/functions';

import ManageFilePreviewComponent from './ManageFilePreviewComponent';
import DownloadButtonPartial from '../partials/DownloadButtonPartial';

const ModalComponent = ({item, link, language}) => {
  const [show, setShow] = useState(false);

  const [previewExtension, setPreviewExtension] = useState(null);
  const [previewId, setPreviewId] = useState(null);
  const [previewHash, setPreviewHash] = useState(null);
  const [activeFile, setActiveFile] = useState(0); 

  const uniqueSeries = functionHelper.getUniqueSeriesNames(item.series);

  const showModal = (itemInfo) => {
    setShow(true);
    setPreviewExtension(itemInfo.download.files[0].ext)
    setPreviewId(itemInfo.download.files[0].id);
    setPreviewHash(itemInfo.download.hash)
  }

  const changePreviewInfo = (key, item) => {
    setPreviewExtension(item.ext)
    setActiveFile(key);
    setPreviewId(item.id);
  }

  return (
    <>
      <Button variant="primary" onClick={() => showModal(item)}>
        Szczegóły
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName='modal-90w'
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <strong>{item.name}</strong>
            <ul className="list-inline seriesList">
              {
                
                uniqueSeries.map((series, key) => {
                  return (
                    <React.Fragment key={key}>
                      <li className="list-inline-item"><small>{series}</small></li>
                    </React.Fragment>
                  );
                })
              }
            </ul>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className='col-sm-12 col-md-4 col-lg-4'>
              <h2 className="text-center">Lista plików do pobrania</h2><hr/>
              <div className="filesListWrapper">
                <ListGroup as="ul" className="filePreview">
                {
                 item.download.files.map((file, key) => {
                    let activeItem = activeFile === key ? true : false; 
                    return(
                      <ListGroup.Item as="li" key={key} active={activeItem} onClick={() => changePreviewInfo(key, file)}>
                        <strong>{file.name}</strong><br/><small>Format pliku: <strong>{file.ext}</strong>, Rozmiar pliku: <strong>{file.bytes}</strong></small>
                      </ListGroup.Item>
                    );
                  })
                }
                </ListGroup>
              </div>
              
              <hr/>
              <div className="d-grid gap-2"><DownloadButtonPartial item={item} language={language} description={"Pobierz"}/></div>
            

            </Col>
            <Col className='col-sm-12 col-md-8 col-lg-8 filePreview'>
              <ManageFilePreviewComponent status={item.download.status} extension={previewExtension} file={previewHash} language={language} id={previewId} />
            </Col>
            
           
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <p><small><strong>Adres URL:</strong> https://baza-wiedzy.klett.pl{link}</small></p>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalComponent;